import React from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { IoIosClose } from "react-icons/io";
import "./BallotBriefModal.scss";

const BallotBriefModal = ({ open, onClose, title, content }) => (
  <Modal open={open} onClose={onClose}>
    <Box className="ballot-brief-modal">
      <div className="ballot-brief-modal__header">
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <IoIosClose size={24} />
        </IconButton>
      </div>
      <Typography className="ballot-brief-modal__content">{content}</Typography>
    </Box>
  </Modal>
);

export default BallotBriefModal;
